import { asPage } from 'src/components/hoc/asPage'
import { ForgotPassword } from 'src/compositions/Auth/ForgotPassword'

export default asPage(ForgotPassword, {
  pageTitle: 'パスワードをお忘れの方は...',
  noindex: true,
})
